<template>
  <!--<div class="bgwithe">
    <el-container>
      <el-main>
        <div class="box">
          <el-form :inline="true" size="small">
            <el-form-item>
              <el-input v-model.trim="inputNum" placeholder="请输入卡号" />
            </el-form-item>
            <el-form-item>
              <el-select v-model="expressStatus" placeholder="快递状态" style="width: 200px">
                <el-option :value="0" label="未启用" />
                <el-option :value="3" label="审核中" />
                <el-option :value="1" label="已发货" />
                <el-option :value="2" label="已驳回" />
                <el-option :value="99" label="全部" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="replaceStatus" placeholder="换卡状态" style="width: 200px">
                <el-option :value="0" label="待换卡" />
                <el-option :value="1" label="已申请" />
                <el-option :value="2" label="下线换卡" />
                <el-option :value="99" label="全部" />
              </el-select>
            </el-form-item>
          </el-form>
          <div>
            <el-button :size="size" @click="list(1)" type="primary" icon="el-icon-search">搜索</el-button>
            <el-button :size="size" @click="importReplaceData" type="info" icon="el-icon-upload">线上换卡</el-button>
            <el-button :size="size" @click="exportExcel" type="success" icon="el-icon-download">导出</el-button>
            <el-button @click="plPass" :size="size" type="warning" icon="el-icon-s-check">批量通过</el-button>
            <el-button type="danger" :size="size" icon="el-icon-s-check" v-on:click="diaFormVisibleNo = true">批量驳回</el-button>
            <el-button @click="initialFlow" :size="size" type="warning" icon="el-icon-upload">初始化流量</el-button>
          </div>
        </div>
        <el-table @selection-change="selectIdChange" ref="multipleTable" :data="tableData" :row-style="{height:'40px',textAlign:'center'}" :cell-style="{height:'5px,0',textAlign:'center'}" :max-height="maxHeight" :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}" border style="width: 100%;margin-top: 1%">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="iccid" label="老Iccid" width="200">
          </el-table-column>
          <el-table-column prop="ordNo" label="订单号" width="200">
          </el-table-column>
          <el-table-column prop="newNumber" label="新卡号" width="200">
          </el-table-column>
          <el-table-column prop="packageId" label="换卡套餐" width="320">
          </el-table-column>'packageFlow','effectSpecs','remainTime','timeSpecs',
          <el-table-column prop="packageFlow" label="套餐量" width="160">
          </el-table-column>
          <el-table-column prop="effectSpecs" label="生效规格" width="160">
          </el-table-column>
          <el-table-column prop="remainTime" label="剩余时间" width="160">
          </el-table-column>
          <el-table-column prop="timeSpecs" label="时间规格" width="160">
          </el-table-column>
          <el-table-column prop="status" label="状态" width="160">
            <template slot-scope="scope">
              <div v-if="scope.row.status===0">待换卡</div>
              <div v-if="scope.row.status===1">已申请</div>
              <div v-if="scope.row.status===2">已屏蔽</div>
            </template>
          </el-table-column>
          <el-table-column prop="consignee" label="收货人" width="160">
          </el-table-column>
          <el-table-column prop="tel" label="收货人电话" width="160">
          </el-table-column>

          <el-table-column prop="address" label="收货地址" width="250">
            <template slot-scope="scope">
              {{scope.row.province}}-{{scope.row.city}}-{{scope.row.area}}-{{scope.row.address}}
            </template>
          </el-table-column>
          <el-table-column prop="expressNumber" label="快递单号" width="120">
          </el-table-column>
          <el-table-column prop="express" label="快递名称" width="100">
          </el-table-column>
          <el-table-column prop="createTime" label="申请时间" width="160">
          </el-table-column>
          <el-table-column prop="expressStatus" label="快递状态">
            <template slot-scope="scope">
              <div v-if="scope.row.expressStatus===0">未启用</div>
              <div v-if="scope.row.expressStatus===1">已发货</div>
              <div v-if="scope.row.expressStatus===2">已驳回</div>
              <div v-if="scope.row.expressStatus===3">审核中</div>
            </template>
          </el-table-column>
          <el-table-column prop="info" label="备注">
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button type="primary" :size="size">
                  操作<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="pass(scope.row.iccid)">换卡通过</el-dropdown-item>
                  <el-dropdown-item @click.native="noPass(scope.row.iccid)">换卡驳回</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>

        <el-dialog v-if="diaReplace" :close-on-click-modal="false" data-height="700" title="审核通过" :visible.sync="diaReplace" class="class_dialog_hospital" width="40%">
          <el-form ref="tableDataId" :model="tableDataId" :rules="rules" label-width="100px" style="display:flex;justify-content: space-between;flex-wrap: wrap;">
            <el-form-item label="新卡号：">
              <el-input v-model.trim="tableDataId.newNumber" placeholder='请输入新卡号' />
            </el-form-item>
            <el-form-item label="快递单号：">
              <el-input v-model.trim="tableDataId.expressNumber" placeholder='请输入快递单号' />
            </el-form-item>
            <el-form-item label="快递名称：" v-if="tableDataId.ordNo.indexOf('app-')!==-1">
              &lt;!&ndash; <el-col v-if="tableDataId.ordNo.indexOf('app-')!==-1" style="padding-left: 9%;"><span></span> &ndash;&gt;
              <el-input v-model.trim="tableDataId.express" placeholder='请输入快递名称' />
              &lt;!&ndash; </el-col> &ndash;&gt;
            </el-form-item>
            <el-form-item label="新卡套餐：" v-if="tableDataId.ordNo.indexOf('app-')!==-1">
              &lt;!&ndash; <el-col v-if="tableDataId.ordNo.indexOf('app-')!==-1"  style="padding-left: 9%;"><span>新卡套餐：</span> &ndash;&gt;
              <el-input v-model.trim="tableDataId.newPackageId" placeholder='请输入新卡套餐' />
              &lt;!&ndash; </el-col> &ndash;&gt;
            </el-form-item>
            <el-form-item label="价格：">
              <el-input v-model.trim="tableDataId.prestorePrice" placeholder='请输入价格' />
            </el-form-item>
            <el-form-item label="备注：">
              <el-input v-model.trim="tableDataId.info" placeholder='请输入备注信息' />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="diaReplace = false">取 消</el-button>
            <el-button size="small" type="primary" @click="addReplace('tableDataId')">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog v-if="noReplace" :close-on-click-modal="false" data-height="700" title="驳回申请" :visible.sync="noReplace" class="class_dialog_hospital" width="40%">
          <el-form ref="tableDataId" :model="tableDataId" style="margin-bottom:70px;">
            <el-col><span>驳回原因：</span>
              <el-input v-model.trim="tableDataId.info" style="width:75%;" placeholder='请填写驳回原因' />
              &lt;!&ndash;<textarea v-model="tableDataId.info" />&ndash;&gt;
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="noReplace = false">取 消</el-button>
            <el-button size="small" type="primary" @click="replaceNoPass('tableDataId')">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="批量驳回" :visible.sync="diaFormVisibleNo" class="class_dialog_hospital" width="40%">
          <div>
            <p style="color:red">老IcciD号为：{{ids}} 的申请您将要进行批量审核驳回操作！</p>
            <div style="display: flex;align-items: center;">
              <div>驳回原因：</div>
              <div>
                <textarea v-model="plinfo" style="width:300px;" placeholder='请填写驳回原因' />
              </div>
            </div>
            &lt;!&ndash;<el-col style=""><span >驳回原因：</span><el-input v-model="plinfo" style="width:42%;" /></el-col>&ndash;&gt;
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="diaFormVisibleNo = false">取 消</el-button>
            <el-button size="small" type="primary" @click="batchNoPass()">确 定</el-button>
          </div>
        </el-dialog>

      </el-main>
    </el-container>

    <el-dialog :close-on-click-modal="false" title="线上换卡" :visible.sync="diaVisImport" class="class_dialog_hospital" width="30%">
      <span class="mestitle">下载模板：<a :href="importUrlA" class="mesage">导入模板A类</a></span>
      <p class="mestitle">系统卡换系统卡/非系统卡换系统卡（均有换卡套餐）</p>
      <span class="mestitle">下载模板：<a :href="importUrlB" class="mesage">导入模板B类</a></span>
      <p class="mestitle">非系统卡换系统卡（无换卡套餐，自定义套餐量）</p>
      <el-upload :disabled="false" ref="upload" style="text-align: center;" class="upload-demo" drag :action="uploadUrl" multiple :limit=limitNum :auto-upload="false" :on-change="fileChange" :before-upload="beforeUploadFile" :on-exceed="exceedFile" :on-success="handleSuccess" :on-error="handleError" :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__tip">只能上传xls/xlsx文件,多个套餐，套餐Id用英文逗号隔开，<br />换卡费用和补卡费用根据实际情况填写！</div>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>

      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="uploadFile">上传到服务器</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="初始化流量  &&  特殊卡转接" :visible.sync="diaInitialFlow" class="class_dialog_hospital" width="30%">
      <span class="mestitle">下载模板：<a :href="importUrl1" class="mesage">导入模板</a></span>
      <br />
      <p />
      <span><span class="mesage">温馨提示：</span> 非系统卡操作完换卡，请先导出模板，填写旧卡剩余流量和金额，再导入数据，完成换卡转接流量余额的操作！新卡号：new_iccid</span>
      <p />
      <span><span class="mesage">温馨提示：</span> 系统卡操作完换卡，接口查询流量异常情况者，旧卡剩余流量，余额均填写1.01，后台自动查询老卡现有流量余额进行转接操作！</span>
      <p />
      <el-upload :disabled="false" ref="upload" style="text-align: center" class="upload-demo" drag :action="initialFlowUrl" multiple :limit=limitNum :auto-upload="false" :on-change="fileChange" :before-upload="beforeUploadFile" :on-exceed="exceedFile" :on-success="initHandleSuccess" :on-error="initHandleError" :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__tip">只能上传xls/xlsx文件</div>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>

      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="initImportFile">上传到服务器</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="批量通过" :visible.sync="diaFormVisiblePass" class="class_dialog_hospital" width="30%">
      <span><span style="color: red;font-size: 17px;font-weight: 700;">温馨提示：</span>请先查询出需要批量换卡通过的数据，操作导出数据后，填写对应的新卡号和快递单号，再导入数据批量通过。</span><br />
      <span><span style="color: red;font-size: 17px;font-weight: 700;">温馨提示：</span>生效规格，剩余时间，时间规格，金额，四列针对赵总特殊换卡填写，其他情况无需填写。（不了解之处联系洋洋）</span><br />
      <span><span style="color: red;font-size: 17px;font-weight: 700;">温馨提示：</span> 必填项 新卡号，快递单号,如有报错请仔细阅读此三条温馨提示，核实是否数据存在问题</span><br />
      <el-upload :disabled="false" ref="upload" style="text-align: center;width:100%;" class="upload-demo" drag :action="ImportUrl" multiple :limit=limitNum :auto-upload="false" :on-change="fileChange" :before-upload="beforeUploadFile" :on-exceed="exceedFile" :on-success="plHandleSuccess" :on-error="plHandleError" :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__tip">只能上传xls/xlsx文件</div>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>

      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="importFilePl">上传到服务器</el-button>
      </div>
    </el-dialog>

  </div>-->
</template>

<script>
import Pagination from '../../components/pagination'
import tools from '../../utils/tools'
import check from '../../static/js/check'

export default {
  name: 'replaceList',
  components: {
    Pagination
  },

  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
  },
  data() {
    return {
      size: 'small',
      maxHeight: 500,
      importUrlA: 'http://' + location.host + '/download/excel/replaceExcel.xlsx',
      importUrlB: 'http://' + location.host + '/download/excel/replaceExcel2.xlsx',
      importUrl1: 'http://' + location.host + '/download/excel/initialFlowExcel.xlsx',
      diaVisImport: false,
      diaInitialFlow: false,
      uploadUrl: process.env.VUE_APP_SERVER + '/system/replace/uploadReplace',
      ImportUrl: process.env.VUE_APP_SERVER + '/system/replace/plImportReplace',
      initialFlowUrl: process.env.VUE_APP_SERVER + '/system/replace/initFlow',
      limitNum: 1,
      fileList: [],
      inputNum: '',
      expressStatus: '',
      replaceStatus: '',
      tableData: [],
      diaFormVisibleNo: false,
      diaFormVisiblePass: false,
      diaReplace: false,
      noReplace: false,
      tableDataId: {},
      ids: '',
      plinfo: ''
    }
  },

  methods: {
    //导出的方法
    exportExcel() {
      let _this = this
      if (JSON.stringify(_this.tableData) !== '[]') {
        /*window.location.href =
                 process.env.VUE_APP_SERVER + "/system/replace/downloadfile?iccid=" + _this.inputNum + "&expressStatus=" + _this.expressStatus;*/
        require.ensure([], () => {
          const { export_json_to_excel } = require('../../excel/Export2Excel')
          const tHeader = ['老Iccid', '订单号', '新卡号', '换卡套餐', '套餐量', '生效规格', '剩余时间', '时间规格', '金额', '收货人', '收货人电话', '省', '市', '区', '收货详址', '快递单号', '快递名称', '申请时间', '备注']
          // 上面设置Excel的表格第一行的标题
          const filterVal = ['iccid', 'ordNo', 'newNumber', 'packageName', 'packageFlow', 'effectSpecs', 'remainTime', 'timeSpecs', 'prestorePrice', 'consignee', 'tel', 'province', 'city', 'area', 'address', 'expressNumber', 'express', 'createTime', 'info']
          // iccid、ordNo是tableData里对象的属性
          const list = this.tableData //把data里的tableData存到list
          const data = this.formatJson(filterVal, list)
          export_json_to_excel(tHeader, data, '换卡excel')
        })
      } else {
        _this.$confirm('没有可导出的数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
      }
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },

    list(page) {
      let _this = this
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      _this.$ajax
        .get(process.env.VUE_APP_SERVER + '/system/replace/getReplaceList', {
          params: {
            current: page,
            size: _this.$refs.pagination.size,
            number: _this.inputNum,
            expressStatus: _this.expressStatus,
            replaceStatus: _this.replaceStatus
          }
        })
        .then(response => {
          _this.tableData = response.data.data.rows
          _this.$refs.pagination.render(page, response.data.data.total)
        })
    },

    //审核通过
    pass(iccid) {
      let _this = this
      _this.diaReplace = true
      _this.$ajax.get(process.env.VUE_APP_SERVER + '/system/replace/getIcdSysCashOut/' + iccid, {}).then(response => {
        _this.tableDataId = response.data.data
      })
    },

    //确定
    addReplace(tableDataId) {
      let _this = this
      _this.$refs[tableDataId].validate(valid => {
        if (valid) {
          _this.$ajax.post(process.env.VUE_APP_SERVER + '/system/replace/updateReplace', _this.tableDataId).then(res => {
            if (res.data.code === '0') {
              _this.$notify.success(res.data.data)
              _this.tableDataId = {}
              _this.diaReplace = false
            } else {
              _this.$notify.error(res.data.msg)
              _this.tableDataId = {}
              _this.diaReplace = false
            }
          })
        } else {
          _this.$notify.error('审核通过失败！')
          return false
        }
      })
    },
    //驳回
    noPass(iccid) {
      let _this = this
      _this.noReplace = true
      _this.$ajax.get(process.env.VUE_APP_SERVER + '/system/replace/getIcdSysCashOut/' + iccid, {}).then(response => {
        _this.tableDataId = response.data.data
      })
    },
    //驳回确定
    replaceNoPass(tableDataId) {
      let _this = this
      if (check.checkIsNull(_this.tableDataId.info)) {
        _this.$swal('驳回操作请注明原因！')
        return false
      }
      _this.$refs[tableDataId].validate(valid => {
        if (valid) {
          _this.$ajax.post(process.env.VUE_APP_SERVER + '/system/replace/replaceNoPass', _this.tableDataId).then(res => {
            if (res.data.code === '0') {
              _this.$notify.success(res.data.data)
              _this.tableDataId = {}
              _this.noReplace = false
            } else {
              _this.$notify.error(res.data.msg)
              _this.tableDataId = {}
              _this.noReplace = false
            }
          })
        } else {
          _this.$notify.error('审核驳回失败！')
          return false
        }
      })
    },
    selectIdChange(val) {
      let _this = this
      _this.multipleSelection = val
      let array = new Array()
      for (let i in _this.multipleSelection) {
        let section = _this.multipleSelection[i]
        let id = section.iccid
        array.push(id)
      }
      let str = array.join(',')
      _this.ids = str
    },

    //plNoPass
    batchNoPass() {
      let _this = this
      if (_this.ids.length == 0 || _this.ids === undefined) {
        _this.$swal('请先勾选需要审核的数据！')
        return false
      }
      if (check.checkIsNull(_this.plinfo)) {
        _this.$swal('驳回操作请注明原因！')
        return false
      }
      _this.$ajax
        .post(process.env.VUE_APP_SERVER + '/system/replace/plReplaceNoPass', {
          ids: _this.ids,
          plinfo: _this.plinfo
        })
        .then(res => {
          if (res.data.code === '0') {
            _this.$notify.success(res.data.data)
            _this.diaFormVisibleNo = false
          } else {
            _this.$notify.error(res.data.msg)
            _this.diaFormVisibleNo = false
          }
        })
    },
    initialFlow() {
      let _this = this
      _this.diaInitialFlow = true
    },
    initImportFile(event) {
      let _this = this
      event.preventDefault()
      _this.$refs.upload.submit()
    },
    initHandleSuccess(res, file, fileList) {
      if (res.code === '0') {
        this.$notify.success({
          title: '成功',
          message: res.data
        })
        this.diaInitialFlow = false
      } else {
        this.$notify.error({
          title: '失败',
          message: res.msg
        })
        this.$refs.upload.clearFiles()
        this.diaInitialFlow = false
      }
    },
    // 文件上传失败时的钩子
    initHandleError(err, file, fileList) {
      this.$notify.error({
        title: '错误',
        message: res.msg
      })
      this.$refs.upload.clearFiles()
    },

    plPass() {
      let _this = this
      _this.diaFormVisiblePass = true
    },
    //批量通过换卡
    importFilePl(event) {
      let _this = this
      event.preventDefault()
      _this.$refs.upload.submit()
    },
    // 文件上传成功时的钩子
    plHandleSuccess(res, file, fileList) {
      if (res.code === '0') {
        this.$notify.success({
          title: '成功',
          message: res.data
        })
        this.diaFormVisiblePass = false
      } else {
        this.$notify.error({
          title: '失败',
          message: res.msg
        })
        this.$refs.upload.clearFiles()
      }
    },
    // 文件上传失败时的钩子
    plHandleError(err, file, fileList) {
      this.$notify.error({
        title: '错误',
        message: res.msg
      })
      this.$refs.upload.clearFiles()
    },

    //上线换卡
    importReplaceData() {
      let _this = this
      _this.diaVisImport = true
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$notify.warning({
          title: '警告',
          message: `只能上传Excel的文件`
        })
        this.$refs.upload.clearFiles()
        return false
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      if (res.code === '0') {
        this.$notify.success({
          title: '成功',
          message: res.data
        })
        this.diaVisImport = false
      } else {
        this.$notify.error({
          title: '失败',
          message: res.msg
        })
        this.$refs.upload.clearFiles()
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: '错误',
        message: `文件上传失败`
      })
      this.$refs.upload.clearFiles()
    },

    uploadFile(event) {
      let _this = this
      event.preventDefault()
      this.$refs.upload.submit()
    },
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$notify.warning({
        title: '警告',
        message: `只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`
      })
      this.$refs.upload.clearFiles()
      return false
    },
    beforeUploadFile(file) {
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$notify.warning({
          title: '警告',
          message: `只能上传Excel的文件`
        })
        this.$refs.upload.clearFiles()
        return false
      }
    }
  }
}
</script>

<style scoped>
/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}
.box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.btns {
  margin-left: 30px;
}
.el-form-item__label .wrapper {
  color: red;
}

._select {
  width: 20%;
  height: 34px;
}
.pup {
  float: right;
}
.col-md-3 {
  float: left;
}
.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
/deep/.el-main {
  text-align: left;
  /*  padding: 20px !important;*/
  overflow: hidden !important;
}
body {
  margin: 0;
}
.el-col-24 {
  width: 100%;
  margin: 10px !important;
}
.mestitle {
  font-size: 15px;
}
.mesage {
  font-size: 17px;
  font-weight: 700;
}
/* --------------------------弹窗样式------------------------------ */
/*标题样式*/
/deep/.class_dialog_hospital .el-dialog__title {
  font-size: 15px;
  margin-left: 15px;
}

/*头区样式*/
/deep/.class_dialog_hospital .el-dialog__header {
  height: 50px;
  background: #e6e6e6;
  padding: 15px 0 4px 10px;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
}

/*头区退出按钮样式*/
/deep/.class_dialog_hospital .el-dialog__headerbtn {
  top: 14px;
  right: 20px;
  font-size: 16px;
}

/*对话框区*/
/deep/.class_dialog_hospital .el-dialog {
  border: 1px solid #dcdfe6;
  box-shadow: 0 0 4px #e6e6e6;
  border-radius: 9px;
  padding: 0;
}

/*内容区*/
/deep/.class_dialog_hospital .el-dialog__body {
  padding: 0;
  padding-top: 20px;
  margin: 0px 20px;
}

/*脚区*/
/deep/.class_dialog_hospital .el-dialog__footer {
  border-top: 2px solid #e8eaec;
  padding: 16px;
}
/deep/.el-upload {
  width: 100%;
}
/deep/.el-upload-dragger {
  width: 100%;
}
.el-upload__text {
  margin-bottom: 30px;
}
/deep/.el-upload {
  width: 100%;
}
/*滚动条样式*/
/deep/ ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}
/deep/ ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  box-shadow: inset 5px 0px 5px #f0f0f0;
  background: #d9d9d9;
}
/deep/ ::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px #f0f0f0;
  border-radius: 8px;
  background: #ffffff;
}
</style>